export interface MediaItem {
  id: string;
  title: string;
  type: "movie" | "tv";
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  releaseDate: string;
  cover: string;
  summary: string;
  content: string;
  tags: string[];
}

export const mediaList: MediaItem[] = [
  {
    id: "mv-01",
    title: "长夜微光",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "悬疑"],
    rating: 8.7,
    duration: "128分钟",
    director: "陈知远",
    cast: ["林知夏", "顾承安", "苏晚"],
    releaseDate: "2024-06-18",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20lone%20figure%20walking%20a%20rainy%20city%20street%20at%20night%2C%20warm%20orange%20and%20deep%20charcoal%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20atmospheric%20moody%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-01&orientation=portrait",
    summary: "一名深夜值班的接线员，因一通来历不明的电话被卷入一桩陈年悬案。",
    content: "《长夜微光》讲述了一名深夜值班的城市应急接线员，在某场暴雨夜里接到一通没有声音的来电。随着她追查号码背后的故事，镜头缓缓揭开一段被时间掩埋的旧案。影片以克制的叙事与细腻的光影，描绘普通人在黑暗中彼此照亮的瞬间。全片气质沉静，节奏沉稳，评论认为它对悬疑与情感的平衡处理得恰到好处。",
    tags: ["热门", "口碑佳作"],
  },
  {
    id: "mv-02",
    title: "山海归途",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["冒险", "剧情"],
    rating: 8.2,
    duration: "142分钟",
    director: "方屿",
    cast: ["周砚青", "许南舟", "叶清和"],
    releaseDate: "2023-09-29",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20solitary%20hiker%20on%20a%20misty%20mountain%20ridge%20at%20dawn%2C%20warm%20terracotta%20and%20slate%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20atmospheric%20moody%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-02&orientation=portrait",
    summary: "一位中年摄影师带着父亲留下的地图，踏上横跨山海的归乡之旅。",
    content: "电影围绕一位事业失意的摄影师展开，他在父亲离世后整理遗物，发现一张标注了陌生地点的旧地图。为寻找答案，他独自踏上旅程，一路遇见形形色色的旅人，也逐渐拼凑出父亲未曾言说的往事。《山海归途》以辽阔的自然风景与内敛的情绪著称，被称为一封写给故乡与和解的长信。",
    tags: ["新上线", "口碑佳作"],
  },
  {
    id: "mv-03",
    title: "无人知晓的夏天",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["青春", "剧情"],
    rating: 7.9,
    duration: "116分钟",
    director: "柳亦白",
    cast: ["沈书桐", "江迟", "林清越"],
    releaseDate: "2022-07-15",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20sunlit%20empty%20school%20rooftop%20in%20summer%20with%20warm%20breeze%2C%20muted%20peach%20and%20soft%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20gentle%20daylight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20nostalgic%20atmosphere%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-03&orientation=portrait",
    summary: "四个少年在毕业前的最后一个夏天，共同守护一个只有他们知道的秘密。",
    content: "故事发生在一座临海小城的中学，四个即将毕业的少年在一次意外中共同保守了一个秘密。那个夏天里，友情、暗恋与离别交织在一起，成为他们后来人生中反复回望的坐标。《无人知晓的夏天》用大量自然光与生活化细节，还原了青春期特有的明亮与笨拙。",
    tags: ["青春"],
  },
  {
    id: "mv-04",
    title: "第七封信",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["悬疑", "犯罪"],
    rating: 8.4,
    duration: "121分钟",
    director: "郭家铭",
    cast: ["何启然", "邓芷晴", "莫子谦"],
    releaseDate: "2024-03-22",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20sealed%20envelope%20on%20a%20dark%20wooden%20desk%20under%20a%20thin%20beam%20of%20light%2C%20warm%20amber%20and%20charcoal%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20tense%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-04&orientation=portrait",
    summary: "七封匿名信接连送到警局，每一封都预告着一桩尚未发生的案件。",
    content: "一位即将退休的老警官收到了第七封匿名信，信中只有一行字和一个日期。随着日期临近，一起看似意外的案件如期发生，他不得不重新审视多年前那桩被他亲手结案的旧事。《第七封信》以紧凑的推理节奏和港式影像质感，构建出一场关于记忆与真相的博弈。",
    tags: ["热门", "悬疑"],
  },
  {
    id: "mv-05",
    title: "雾里看花",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    rating: 7.6,
    duration: "109分钟",
    director: "苏婉宁",
    cast: ["温以宁", "程慕言", "白鹿鸣"],
    releaseDate: "2021-11-05",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20two%20silhouettes%20standing%20apart%20in%20a%20foggy%20garden%20at%20dusk%2C%20soft%20peach%20and%20dusty%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20dreamy%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20romantic%20melancholy%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-05&orientation=portrait",
    summary: "一场因误会分开的重逢，让两个成年人在雾般的往事里重新看清彼此。",
    content: "影片讲述一对曾在大学相恋的男女，在多年后的一场同学聚会上意外重逢。彼时两人都以为对方早已释怀，却在一夜长谈中重新触碰旧日的误会。电影以大量留白与舒缓的节奏，探讨成年人在爱情中的犹豫与坦诚，被誉为近年少见的口碑文艺爱情片。",
    tags: ["文艺"],
  },
  {
    id: "mv-06",
    title: "逆流而上",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["励志", "剧情"],
    rating: 8.0,
    duration: "134分钟",
    director: "赵行舟",
    cast: ["韩毅然", "倪以恒", "宋书宁"],
    releaseDate: "2023-12-01",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20swimmer%20cutting%20through%20dark%20water%20seen%20from%20above%2C%20energetic%20orange%20and%20deep%20navy%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20determined%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-06&orientation=portrait",
    summary: "一支濒临解散的业余游泳队，为了最后一次比赛拼尽全力。",
    content: "在一座小城的旧体育馆里，一支无人看好的业余游泳队正面临解散。新来的年轻教练决定带着队员们在市级比赛前完成一场几乎不可能的逆袭。影片以真实、热血的训练场面与群像刻画，讲述了普通人如何用坚持回应质疑。",
    tags: ["励志", "热门"],
  },
  {
    id: "mv-07",
    title: "时光邮局",
    type: "movie",
    year: 2024,
    region: "日本",
    genres: ["奇幻", "爱情"],
    rating: 8.6,
    duration: "118分钟",
    director: "中村悠",
    cast: ["藤原绫", "佐仓凉", "宫下结衣"],
    releaseDate: "2024-08-10",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20tiny%20old%20post%20office%20in%20a%20quiet%20snowy%20town%20at%20evening%2C%20warm%20peach%20and%20soft%20blue%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20cozy%20glowing%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20tender%20atmosphere%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-07&orientation=portrait",
    summary: "小镇上一间神奇邮局，可以把信寄给过去的自己。",
    content: "故事发生在一座终年落雪的小镇，那里有一间只在深夜营业的邮局，据说投递的信件能够送到写信人过去的自己手中。一位总在懊悔中生活的年轻女子，决定寄出第一封信，从而卷入了与时日、选择与遗憾相关的一连串温柔奇遇。影片以细腻的情感与柔和的影像，带来一个关于释怀的童话。",
    tags: ["口碑佳作", "奇幻"],
  },
  {
    id: "mv-08",
    title: "沉默的证词",
    type: "movie",
    year: 2022,
    region: "韩国",
    genres: ["犯罪", "悬疑"],
    rating: 8.8,
    duration: "126分钟",
    director: "朴正宇",
    cast: ["金度允", "李泫雅", "崔敏载"],
    releaseDate: "2022-05-27",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20an%20empty%20courtroom%20chair%20lit%20by%20a%20single%20shaft%20of%20light%2C%20deep%20charcoal%20and%20warm%20amber%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20solemn%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-08&orientation=portrait",
    summary: "一位不能开口的证人，用文字还原了一桩无人敢碰的真相。",
    content: "一名因事故失去发声能力的年轻证人，成为一桩重大案件唯一的目击者。面对来自各方的压力，她只能以笔代口，在法庭上一次又一次写下证词。影片节奏紧绷、情绪克制，被评价为对司法与人性的深刻凝视。",
    tags: ["口碑佳作", "犯罪"],
  },
  {
    id: "mv-09",
    title: "风起长安",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "历史"],
    rating: 8.1,
    duration: "147分钟",
    director: "裴景川",
    cast: ["陆沉舟", "谢云归", "柳明湖"],
    releaseDate: "2023-10-01",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20ancient%20Chinese%20city%20walls%20under%20a%20wide%20sunset%20sky%2C%20warm%20amber%20and%20ink%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20epic%20golden%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20majestic%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-09&orientation=portrait",
    summary: "盛世长安的风起云涌中，一介书生被卷入朝堂与江湖的漩涡。",
    content: "影片以古都长安为背景，讲述一位初入仕途的年轻书生在无意间得到一封密函后，被迫在朝堂纷争与江湖恩怨之间做出抉择。宏大的场景调度与考究的美术设计，让这座古都的繁华与暗涌同时呈现。",
    tags: ["古装", "热门"],
  },
  {
    id: "mv-10",
    title: "深海回声",
    type: "movie",
    year: 2024,
    region: "英国",
    genres: ["科幻", "悬疑"],
    rating: 7.7,
    duration: "131分钟",
    director: "Oliver Grant",
    cast: ["Ethan Cole", "Mia Fenwick", "Noah Blake"],
    releaseDate: "2024-04-19",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20solitary%20submersible%20descending%20into%20deep%20ocean%20darkness%20with%20a%20faint%20warm%20glow%2C%20teal%20grey%20and%20amber%20accents%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20mysterious%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-10&orientation=portrait",
    summary: "一支深海考察队在万米海底，收到了一段不该存在的回声。",
    content: "一支国际深海考察队在执行例行探测时，意外捕捉到一段有规律的信号。随着他们向更深处下潜，队员之间对这段回声来源的判断产生了分歧。影片以压抑的空间感与音效设计，营造出深海探索独有的未知与敬畏。",
    tags: ["科幻"],
  },
  {
    id: "mv-11",
    title: "一球成名记",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["运动", "喜剧"],
    rating: 7.3,
    duration: "112分钟",
    director: "胡乐天",
    cast: ["钱多多", "韦小北", "邓一鸣"],
    releaseDate: "2021-08-20",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20community%20football%20pitch%20at%20sunset%20with%20a%20single%20ball%20in%20the%20air%2C%20lively%20orange%20and%20grass%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20warm%20daylight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20upbeat%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-11&orientation=portrait",
    summary: "一群社区大叔组建的野球队，意外闯进了城市联赛。",
    content: "在一座老城区里，几位早已告别球场的普通中年人重新凑起了一支球队。没有专业训练、没有赞助，他们却因为一次报名失误被卷进了城市联赛。影片笑中带暖，用生活化的细节讲述平凡人对热爱的执拗。",
    tags: ["喜剧"],
  },
  {
    id: "mv-12",
    title: "我们的昨天",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    rating: 7.8,
    duration: "120分钟",
    director: "安然",
    cast: ["夏末", "顾时予", "钟离"],
    releaseDate: "2023-06-09",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20an%20old%20film%20camera%20resting%20on%20a%20windowsill%20with%20afternoon%20light%2C%20soft%20peach%20and%20warm%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20gentle%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20nostalgic%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-12&orientation=portrait",
    summary: "两位老友用一台旧相机，重新拼起二十年前未能拍完的青春。",
    content: "一位纪录片导演回到故乡整理旧物，发现了一卷从未冲洗的胶卷。为了完成当年未竟的约定，他找到散落各地的老同学们，一起补拍那部被搁置的青春影像。影片在回忆与现实之间往返，温柔而克制。",
    tags: ["爱情"],
  },
  {
    id: "mv-13",
    title: "荒原旅人",
    type: "movie",
    year: 2022,
    region: "美国",
    genres: ["冒险", "剧情"],
    rating: 8.3,
    duration: "138分钟",
    director: "Daniel Reeves",
    cast: ["Jack Holloway", "Ella Moore", "Ryan Pace"],
    releaseDate: "2022-10-14",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20lone%20traveler%20crossing%20a%20vast%20dusty%20desert%20highway%2C%20burnt%20orange%20and%20sand%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20harsh%20sunlight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20lonely%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-13&orientation=portrait",
    summary: "一位失去方向的旅人，在广袤荒原上遇见改变他一生的陌生人。",
    content: "影片讲述一名在中年迷失方向的男子，独自开车穿越广袤荒原的旅程。途中，他遇到一位同样在逃避过去的搭车客，两人在漫长公路上交换各自的故事。作品以壮阔的自然景观与沉静的对话，探讨孤独与重新出发。",
    tags: ["口碑佳作"],
  },
  {
    id: "mv-14",
    title: "星尘之下",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.5,
    duration: "149分钟",
    director: "Sophia Lin",
    cast: ["Owen Reed", "Harper Quinn", "Leo Vance"],
    releaseDate: "2024-07-26",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20small%20spaceship%20silhouette%20against%20a%20warm%20amber%20nebula%20and%20dark%20space%2C%20cosmic%20orange%20and%20deep%20indigo%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20epic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20wondrous%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-14&orientation=portrait",
    summary: "在一颗即将熄灭的星球上，一支小队踏上寻找新家园的征途。",
    content: "影片设定在一颗恒星即将走向终点的宜居行星上，人类最后的探索小队启程寻找可能的迁徙之地。漫长的星际旅途中，队员们的信念不断受到考验。作品以恢弘的视觉与人文关怀，讲述希望如何穿越无垠星尘。",
    tags: ["热门", "科幻"],
  },
  {
    id: "mv-15",
    title: "玻璃城堡",
    type: "movie",
    year: 2021,
    region: "法国",
    genres: ["剧情", "家庭"],
    rating: 7.5,
    duration: "113分钟",
    director: "Camille Rousseau",
    cast: ["Léa Marchand", "Hugo Bernard", "Nina Petit"],
    releaseDate: "2021-09-03",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20delicate%20glass%20house%20model%20on%20a%20table%20with%20soft%20window%20light%2C%20soft%20rose%20and%20warm%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20gentle%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20fragile%20tender%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-15&orientation=portrait",
    summary: "一个看似完美的家庭，在一次搬家后逐渐显露出裂痕。",
    content: "表面上幸福体面的一个四口之家，因为一次仓促的搬家而被打破平衡。随着新环境带来的压力，隐藏在日常之下的矛盾一点点浮现。影片以细腻的家庭群像与冷静的镜头语言，讨论亲密关系中的理解与原谅。",
    tags: ["家庭"],
  },
  {
    id: "mv-16",
    title: "追风者",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["动作", "犯罪"],
    rating: 7.9,
    duration: "124分钟",
    director: "关山岳",
    cast: ["雷正阳", "秦九", "白砚"],
    releaseDate: "2023-08-11",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20motorcycle%20leaning%20into%20a%20wet%20night%20highway%20curve%20with%20light%20trails%2C%20vivid%20orange%20and%20dark%20charcoal%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20fast%20tense%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-16&orientation=portrait",
    summary: "一名退役赛车手，为查明弟弟之死重返危险的赛道世界。",
    content: "退役多年的赛车手在弟弟意外身亡后，重新回到那条他曾发誓不再踏足的赛道。为了接近真相，他不得不与昔日对手和地下车队周旋。影片动作场面干脆利落，同时保留了对亲情与救赎的刻画。",
    tags: ["动作"],
  },
  {
    id: "mv-17",
    title: "无声潮汐",
    type: "movie",
    year: 2024,
    region: "韩国",
    genres: ["剧情", "悬疑"],
    rating: 8.9,
    duration: "130分钟",
    director: "郑义尚",
    cast: ["孙智勋", "韩素妍", "吴在锡"],
    releaseDate: "2024-02-16",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20quiet%20fishing%20harbor%20at%20grey%20dawn%20with%20still%20water%2C%20muted%20amber%20and%20cool%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20subdued%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20somber%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-17&orientation=portrait",
    summary: "小镇港口的潮水退去后，埋藏多年的秘密随之浮出水面。",
    content: "在一座靠海为生的小镇上，一次罕见的退潮露出了一艘沉没多年的小船。以此为开端，镇上几户人家刻意回避的往事被逐一揭开。影片节奏沉稳、表演克制，被誉为当年最具分量的剧情悬疑片之一。",
    tags: ["口碑佳作", "热门"],
  },
  {
    id: "mv-18",
    title: "南方来信",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 8.0,
    duration: "119分钟",
    director: "何蔚然",
    cast: ["苏念", "梁叙", "许安然"],
    releaseDate: "2022-03-18",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20stack%20of%20handwritten%20letters%20beside%20a%20cup%20of%20tea%20by%20a%20sunny%20window%2C%20warm%20peach%20and%20soft%20beige%20tones%2C%20soft%20gradient%20simple%20background%2C%20gentle%20daylight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20warm%20nostalgic%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-18&orientation=portrait",
    summary: "母亲病重后，女儿从南方寄来的每一封信都被悄悄收进抽屉。",
    content: "一位在北方的母亲在病重之后，开始翻看女儿多年来从南方寄回家的信。信件跨越十多年，记录着两代人各自的坚持与妥协。影片以书信为线索，串起一个关于亲情、距离与理解的故事。",
    tags: ["家庭"],
  },
  {
    id: "mv-19",
    title: "雪原慢车",
    type: "movie",
    year: 2023,
    region: "日本",
    genres: ["剧情", "奇幻"],
    rating: 7.4,
    duration: "117分钟",
    director: "森川凉介",
    cast: ["高桥澪", "小林凪", "石田悠真"],
    releaseDate: "2023-12-15",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20single%20train%20car%20moving%20through%20a%20snowy%20countryside%20at%20dusk%2C%20warm%20amber%20window%20glow%20and%20cool%20grey%20snow%2C%20soft%20gradient%20simple%20background%2C%20quiet%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20serene%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-19&orientation=portrait",
    summary: "一列只在雪夜出现的慢车，载着乘客驶向他们最想回到的时刻。",
    content: "在一段被大雪覆盖的支线上，运行着一列时刻表上查不到的慢车。每当车厢灯亮起，乘客们便会发现自己正驶向记忆中最想重返的一天。影片以缓慢的节奏与静谧的画面，讲述关于放下与告别的温柔寓言。",
    tags: ["奇幻"],
  },
  {
    id: "mv-20",
    title: "城市之光影",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "剧情"],
    rating: 7.2,
    duration: "115分钟",
    director: "罗一川",
    cast: ["章呈", "叶澜", "许星河"],
    releaseDate: "2024-05-10",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20city%20skyline%20reflected%20in%20a%20rainy%20window%20with%20warm%20lights%2C%20orange%20and%20slate%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20glowing%20evening%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20urban%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-20&orientation=portrait",
    summary: "三个初入社会的年轻人在大城市里，为各自的光影梦想奔波。",
    content: "影片聚焦三位刚走出校园、合租在同一间小公寓里的年轻人。他们分别做着不同的工作，却都在为各自的理想摸索方向。作品用轻快的节奏与真实的细节，描摹当代都市青年的迷茫与坚持。",
    tags: ["都市"],
  },
  {
    id: "mv-21",
    title: "最后的灯塔",
    type: "movie",
    year: 2021,
    region: "英国",
    genres: ["剧情", "悬疑"],
    rating: 8.2,
    duration: "127分钟",
    director: "George Miller",
    cast: ["Arthur Hale", "Rose Bennett", "Sam Doyle"],
    releaseDate: "2021-11-26",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20film%20poster%20artwork%20of%20a%20lighthouse%20standing%20alone%20on%20a%20stormy%20cliff%20at%20night%2C%20warm%20beacon%20amber%20and%20deep%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20mysterious%20turbulent%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-mv-21&orientation=portrait",
    summary: "一座孤岛灯塔的最后一位守护者，发现那里藏着远超想象的秘密。",
    content: "灯塔自动化改造后，岛上只留下一位即将离任的老守护者。在整理设备的日子里，他逐渐发现这座灯塔记载着一段无人知晓的历史。影片以孤岛空间与海浪声营造出独特的氛围，讲述记忆与守望。",
    tags: ["口碑佳作"],
  },
  {
    id: "tv-01",
    title: "云海之上",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "都市"],
    rating: 8.3,
    duration: "全40集",
    director: "陆怀远",
    cast: ["江知遇", "沈云舒", "温言"],
    releaseDate: "2024-04-08",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20young%20woman%20looking%20out%20over%20a%20sea%20of%20clouds%20from%20a%20high%20plateau%2C%20warm%20peach%20and%20soft%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20hopeful%20morning%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20uplifting%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-01&orientation=portrait",
    summary: "一位都市白领辞职前往高原支教，在云海之上重新找到人生的方向。",
    content: "剧集讲述一位在大城市工作多年的白领，因一次机缘前往高原小镇支教。面对陌生的环境与一群充满好奇心的孩子，她逐渐放下焦虑，也重新思考自己想要的生活。全剧以细腻的人物关系与开阔的自然风光，传递温和而坚定的力量。",
    tags: ["热门", "都市"],
  },
  {
    id: "tv-02",
    title: "理想边界",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "职场"],
    rating: 8.0,
    duration: "全36集",
    director: "顾承泽",
    cast: ["程亦南", "舒晚", "陆明川"],
    releaseDate: "2023-07-19",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20modern%20glass%20office%20tower%20at%20golden%20hour%20seen%20from%20below%2C%20warm%20orange%20and%20cool%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20crisp%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20ambitious%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-02&orientation=portrait",
    summary: "一群建筑设计师在城市更新项目中，坚守各自的理想与底线。",
    content: "剧集围绕一家建筑设计事务所展开，年轻的设计师们接手了一个旧城改造项目。在商业利益与人文情怀之间，他们不断碰撞、妥协又坚持。作品以扎实的行业细节和群像刻画，讨论理想在现实中的边界。",
    tags: ["职场"],
  },
  {
    id: "tv-03",
    title: "午夜诊疗室",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["剧情", "医疗"],
    rating: 8.6,
    duration: "全16集",
    director: "姜河俊",
    cast: ["尹素拉", "朴道贤", "李世妍"],
    releaseDate: "2024-01-12",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20dimly%20lit%20hospital%20corridor%20at%20midnight%20with%20warm%20light%20spilling%20from%20a%20doorway%2C%20warm%20amber%20and%20cool%20clinical%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20moody%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20quiet%20tense%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-03&orientation=portrait",
    summary: "一间只在深夜开放的诊疗室，接待着不愿在白天出现的人们。",
    content: "在一家综合医院里，有一间只在午夜到凌晨开放的特殊诊疗室。值班医生用耐心与专业，接待着那些白天不愿面对自己的人们。每一集以一个病例为切口，讨论身体与心理的种种困境，情感真挚而克制。",
    tags: ["口碑佳作"],
  },
  {
    id: "tv-04",
    title: "三月的约定",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["爱情", "青春"],
    rating: 7.7,
    duration: "全30集",
    director: "温以安",
    cast: ["纪淮", "沈知夏", "陈屿"],
    releaseDate: "2022-03-01",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20cherry%20blossoms%20along%20a%20quiet%20campus%20path%20in%20early%20spring%2C%20soft%20peach%20and%20fresh%20green%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20bright%20spring%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20youthful%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-04&orientation=portrait",
    summary: "毕业季许下的约定，在十年后的春天重新被想起。",
    content: "大学时代的两个年轻人曾约定，十年后的三月无论身在何处都要回到母校。剧集以这个约定为轴，交织呈现他们各自的成长与错过。清新明快的影像与克制的情绪，让这段青春故事显得格外真实。",
    tags: ["青春"],
  },
  {
    id: "tv-05",
    title: "逐光少年",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["青春", "励志"],
    rating: 8.1,
    duration: "全32集",
    director: "雷知白",
    cast: ["许望", "宋一诺", "梁叙白"],
    releaseDate: "2023-06-23",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20teenagers%20cycling%20toward%20a%20low%20sun%20on%20a%20country%20road%2C%20energetic%20orange%20and%20warm%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20golden%20hour%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20hopeful%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-05&orientation=portrait",
    summary: "一群来自小城的少年，为了站上更大的舞台一路向前。",
    content: "剧集讲述一群来自小城的少年，在一次次挫折与选拔中互相扶持、共同成长。他们有各自的天赋与短板，也都有不愿放弃的理由。作品节奏明快，充满朝气，被认为是近年少见的热血成长题材。",
    tags: ["励志"],
  },
  {
    id: "tv-06",
    title: "长安夜行录",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    rating: 8.7,
    duration: "全24集",
    director: "裴景川",
    cast: ["陆沉舟", "苏轻寒", "白砚之"],
    releaseDate: "2024-03-15",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20lantern%20lit%20ancient%20chinese%20street%20at%20night%20with%20mist%2C%20warm%20amber%20lanterns%20and%20ink%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20mysterious%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20suspenseful%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-06&orientation=portrait",
    summary: "古都入夜后接连发生奇案，一位年轻推官抽丝剥茧追寻真相。",
    content: "剧集以古都入夜后的城市为舞台，讲述了年轻推官与搭档联手侦破一系列离奇案件的经过。每一桩案子看似独立，背后却又隐隐相连。考究的美术与紧凑的推理，让这部古装悬疑剧备受关注。",
    tags: ["热门", "古装"],
  },
  {
    id: "tv-07",
    title: "迷雾追踪",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.4,
    duration: "全28集",
    director: "关山岳",
    cast: ["秦九", "雷正阳", "白砚"],
    releaseDate: "2023-09-05",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20foggy%20forest%20road%20with%20distant%20headlights%20cutting%20through%20mist%2C%20cool%20grey%20and%20warm%20amber%20accents%2C%20soft%20gradient%20simple%20background%2C%20tense%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20brooding%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-07&orientation=portrait",
    summary: "一桩跨越多年的连环案件，让两位刑警重新走到一起。",
    content: "多年之后，一桩曾被搁置的连环案件再次出现相似的线索，两位性格迥异的刑警因此重新搭档。随着调查深入，他们发现真相远比想象复杂。剧集节奏紧凑，人物关系真实，是口碑颇佳的犯罪悬疑作品。",
    tags: ["悬疑"],
  },
  {
    id: "tv-08",
    title: "向阳小院",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["家庭", "剧情"],
    rating: 7.9,
    duration: "全34集",
    director: "安然",
    cast: ["周慧", "老顾", "林小满"],
    releaseDate: "2022-11-11",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20warm%20sunlit%20old%20courtyard%20with%20plants%20and%20a%20bicycle%2C%20soft%20peach%20and%20warm%20beige%20tones%2C%20soft%20gradient%20simple%20background%2C%20gentle%20daylight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20cozy%20healing%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-08&orientation=portrait",
    summary: "一座老院子里几户人家，把寻常日子过得热气腾腾。",
    content: "在一座有着几十年历史的老院子里，住着几户性格各异的邻居。柴米油盐之间，有摩擦也有扶持，有争吵也有和解。剧集用平实的烟火气与温情的群像，讲述普通家庭的守望相助。",
    tags: ["家庭"],
  },
  {
    id: "tv-09",
    title: "家书万里",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["历史", "剧情"],
    rating: 8.2,
    duration: "全38集",
    director: "柳亦白",
    cast: ["何知远", "苏念安", "程亦南"],
    releaseDate: "2021-10-08",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20an%20old%20letter%20and%20a%20fountain%20pen%20on%20a%20wooden%20table%20under%20warm%20lamp%20light%2C%20warm%20amber%20and%20sepia%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20cozy%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20nostalgic%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-09&orientation=portrait",
    summary: "一卷跨越数十年的家书，见证了一个普通家族的迁徙与团圆。",
    content: "剧集以一卷被精心保存的家书为线索，讲述一个普通家族跨越数十年的迁徙与变迁。每一封书信都对应着一段时代记忆，也牵动着人物之间深厚的牵绊。作品厚重而克制，被誉为写给家国的长卷。",
    tags: ["历史"],
  },
  {
    id: "tv-10",
    title: "小巷烟火",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "家庭"],
    rating: 8.5,
    duration: "全36集",
    director: "顾承泽",
    cast: ["林清越", "江迟", "柳明湖"],
    releaseDate: "2024-06-01",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20narrow%20old%20alley%20at%20dusk%20with%20warmly%20lit%20shop%20signs%20and%20steaming%20food%20stalls%2C%20warm%20orange%20and%20soft%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20cozy%20evening%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20lively%20warm%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-10&orientation=portrait",
    summary: "一条老巷子里的几户人家，记录着城市变迁中的悲欢离合。",
    content: "剧集把镜头对准一条即将改造的老巷子，讲述其中几户人家在时代变迁中的选择与坚守。小吃铺、杂货店、老住户，构成了生动的市井图景。作品既有烟火气，也有对城市与人情的思考，口碑与热度兼具。",
    tags: ["热门", "家庭"],
  },
  {
    id: "tv-11",
    title: "律政新星",
    type: "tv",
    year: 2023,
    region: "韩国",
    genres: ["职场", "剧情"],
    rating: 7.8,
    duration: "全20集",
    director: "郑义尚",
    cast: ["韩素妍", "孙智勋", "吴在锡"],
    releaseDate: "2023-05-12",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20scales%20of%20justice%20and%20a%20stack%20of%20law%20books%20on%20a%20desk%20with%20warm%20side%20light%2C%20warm%20amber%20and%20cool%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20crisp%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20serious%20focused%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-11&orientation=portrait",
    summary: "初入律所的年轻律师，在真实案件里学会何为职业与良知。",
    content: "剧集讲述几位怀揣理想的年轻律师进入同一家律所后的成长历程。从校园走进真实法庭，他们在一次次棘手案件中学习专业，也逐渐厘清自己坚持的准则。作品节奏明快，兼具职场质感与人文关怀。",
    tags: ["职场"],
  },
  {
    id: "tv-12",
    title: "沧海拾贝",
    type: "tv",
    year: 2022,
    region: "日本",
    genres: ["剧情", "治愈"],
    rating: 8.0,
    duration: "全12集",
    director: "森川凉介",
    cast: ["高桥澪", "石田悠真", "宫下结衣"],
    releaseDate: "2022-08-26",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20small%20seaside%20workshop%20with%20shells%20and%20handmade%20crafts%20by%20sunny%20window%2C%20soft%20peach%20and%20pale%20blue%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20bright%20natural%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20calm%20healing%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-12&orientation=portrait",
    summary: "回到海边小镇的年轻人，用一间手作小店安放自己的节奏。",
    content: "剧集讲述一位厌倦了都市节奏的年轻人回到出生的小镇，开了一家贩卖手作的小店。在与街坊邻居的日常相处中，他慢慢找回生活的从容。全剧节奏舒缓，画面清新，是典型的治愈系作品。",
    tags: ["治愈"],
  },
  {
    id: "tv-13",
    title: "岁月的车票",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    rating: 7.6,
    duration: "全26集",
    director: "温以安",
    cast: ["纪淮", "周慧", "陈屿"],
    releaseDate: "2021-12-03",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20an%20old%20train%20ticket%20and%20a%20leather%20suitcase%20on%20a%20station%20bench%2C%20warm%20amber%20and%20sepia%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20nostalgic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20bittersweet%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-13&orientation=portrait",
    summary: "一张张旧车票，串起一家三代人聚散离合的故事。",
    content: "剧集从一张泛黄的旧车票讲起，串联起一个家庭三代人的聚散离合。有人在站台上告别，有人在归途中重逢。作品以温柔细腻的笔触，讲述时间如何带走也如何留下。",
    tags: ["家庭"],
  },
  {
    id: "tv-14",
    title: "星河彼岸",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.8,
    duration: "全10集",
    director: "Sophia Lin",
    cast: ["Owen Reed", "Harper Quinn", "Leo Vance"],
    releaseDate: "2024-02-02",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20space%20station%20silhouette%20against%20a%20warm%20amber%20nebula%20and%20star%20field%2C%20cosmic%20orange%20and%20deep%20indigo%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20epic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20awe%20inspiring%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-14&orientation=portrait",
    summary: "殖民飞船航行数百年后，船员们对官方给出的目的地产生怀疑。",
    content: "一艘承载着人类希望的殖民飞船已在星际间航行数百年。当新一代船员开始翻阅被尘封的航行记录时，他们对官方公布的目的地产生了疑问。剧集以宏大的宇宙设定与层层推进的悬念，探讨信任与探索的代价。",
    tags: ["科幻", "热门"],
  },
  {
    id: "tv-15",
    title: "春风小城",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["都市", "爱情"],
    rating: 7.5,
    duration: "全30集",
    director: "苏婉宁",
    cast: ["温以宁", "程慕言", "白鹿鸣"],
    releaseDate: "2023-03-28",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20quiet%20southern%20town%20canal%20with%20willow%20trees%20in%20spring%2C%20soft%20peach%20and%20fresh%20green%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20bright%20spring%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20gentle%20romantic%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-15&orientation=portrait",
    summary: "回到家乡小城创业的两个人，在慢节奏里重新遇见彼此。",
    content: "剧集讲述两位年轻人先后回到家乡小城，各自做着看似平常的事业。在熟悉的街巷与慢下来的时光里，两人从误会到理解，重新走近彼此。作品风景清新、节奏舒缓，是轻盈治愈的都市爱情剧。",
    tags: ["爱情"],
  },
  {
    id: "tv-16",
    title: "暗夜守护者",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["动作", "犯罪"],
    rating: 8.1,
    duration: "全12集",
    director: "Daniel Reeves",
    cast: ["Jack Holloway", "Ella Moore", "Ryan Pace"],
    releaseDate: "2022-09-16",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20lone%20figure%20on%20a%20wet%20city%20street%20under%20streetlights%20at%20night%2C%20vivid%20orange%20and%20dark%20charcoal%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20gritty%20tense%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-16&orientation=portrait",
    summary: "一支民间志愿巡逻队，用各自的方式守护着城市夜晚的安宁。",
    content: "剧集聚焦一支由普通人组成的民间志愿巡逻队。他们白天有各自的工作，夜晚则穿梭在城市的街头巷尾，帮助那些需要帮助的人。作品动作场面干脆，人物塑造扎实，传递出平凡人的担当。",
    tags: ["动作"],
  },
  {
    id: "tv-17",
    title: "山与海的书店",
    type: "tv",
    year: 2024,
    region: "日本",
    genres: ["治愈", "剧情"],
    rating: 8.3,
    duration: "全12集",
    director: "中村悠",
    cast: ["藤原绫", "佐仓凉", "宫下结衣"],
    releaseDate: "2024-05-24",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20small%20seaside%20bookstore%20with%20open%20door%20and%20warm%20lamp%20at%20dusk%2C%20soft%20peach%20and%20pale%20blue%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20cozy%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20quiet%20warm%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-17&orientation=portrait",
    summary: "开在山海之间的旧书店，为每位到访者推荐一本恰好需要的书。",
    content: "剧集讲述一间开在山与海之间的旧书店，店主总能为到访的客人推荐一本恰好需要的书。每一位客人都有自己的故事与烦恼，而书成为他们与生活和解的桥梁。全剧温柔细腻，被誉为写给阅读者的情书。",
    tags: ["治愈", "口碑佳作"],
  },
  {
    id: "tv-18",
    title: "破晓之前",
    type: "tv",
    year: 2023,
    region: "英国",
    genres: ["悬疑", "剧情"],
    rating: 8.6,
    duration: "全8集",
    director: "George Miller",
    cast: ["Arthur Hale", "Rose Bennett", "Sam Doyle"],
    releaseDate: "2023-10-20",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20quiet%20english%20village%20street%20before%20dawn%20with%20one%20lit%20window%2C%20deep%20grey%20and%20warm%20amber%20accents%2C%20soft%20gradient%20simple%20background%2C%20moody%20low%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20mysterious%20calm%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-18&orientation=portrait",
    summary: "宁静小镇的一桩失踪案，在破晓之前牵出层层谜团。",
    content: "剧集以一座看似宁静的英国小镇为背景，一名居民在深夜失踪，打破了这里的平静。随着调查展开，邻里之间隐藏的关系与秘密被逐渐揭开。作品氛围冷峻、结构精巧，是备受好评的悬疑剧。",
    tags: ["悬疑", "口碑佳作"],
  },
  {
    id: "tv-19",
    title: "甜橙时代",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "喜剧"],
    rating: 7.4,
    duration: "全28集",
    director: "胡乐天",
    cast: ["钱多多", "韦小北", "邓一鸣"],
    releaseDate: "2024-07-05",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20bright%20college%20dorm%20window%20with%20orange%20flowers%20and%20afternoon%20light%2C%20vivid%20orange%20and%20fresh%20white%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20cheerful%20daylight%2C%20elegant%20negative%20space%20for%20a%20title%2C%20playful%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-19&orientation=portrait",
    summary: "大学宿舍里的四个室友，把平凡日常过成了一部轻喜剧。",
    content: "剧集围绕大学宿舍里的四个性格迥异的室友展开。他们一起上课、熬夜、闯祸，也一起成长。作品用轻松的喜剧节奏与真实的校园细节，记录青春里那些让人会心一笑的瞬间。",
    tags: ["喜剧"],
  },
  {
    id: "tv-20",
    title: "大地之上",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["历史", "战争"],
    rating: 8.4,
    duration: "全40集",
    director: "裴景川",
    cast: ["陆沉舟", "谢云归", "何知远"],
    releaseDate: "2021-09-15",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20vast%20golden%20wheat%20field%20under%20a%20wide%20dramatic%20sky%2C%20warm%20amber%20and%20earth%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20epic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20grand%20solemn%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-20&orientation=portrait",
    summary: "动荡年代里，一群普通人用坚韧守护着脚下的土地。",
    content: "剧集以动荡年代为背景，讲述一群普通人在艰难岁月中守护家园、守望相助的故事。宏大的历史场面与细腻的人物命运交织，让观众在波澜壮阔中看到个体的重量。作品制作精良，广受好评。",
    tags: ["历史"],
  },
  {
    id: "tv-21",
    title: "未来日记本",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["科幻", "悬疑"],
    rating: 7.9,
    duration: "全24集",
    director: "罗一川",
    cast: ["章呈", "叶澜", "许星河"],
    releaseDate: "2023-11-17",
    cover: "https://readdy.ai/api/search-image?query=A%20minimal%20cinematic%20tv%20series%20poster%20artwork%20of%20a%20glowing%20notebook%20on%20a%20dark%20desk%20with%20faint%20digital%20light%2C%20warm%20orange%20and%20cool%20slate%20grey%20tones%2C%20soft%20gradient%20simple%20background%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%20for%20a%20title%2C%20intriguing%20mood%2C%20consistent%20poster%20series%20visual%20style&width=600&height=900&seq=pcm-tv-21&orientation=portrait",
    summary: "一本会显示明日片段的日记本，让平凡的上班族陷入两难。",
    content: "剧集讲述一位普通上班族意外得到一本日记本，翻开之后竟能看见第二天发生的片段。起初他借此避开麻烦，却渐渐发现每一次改变都会带来新的连锁反应。作品以轻科幻设定包裹现实思考，节奏引人入胜。",
    tags: ["科幻"],
  },
];